import getTranslate from './getTranslate';
import setTranslate from './setTranslate';
import minTranslate from './minTranslate';
import maxTranslate from './maxTranslate';
import translateTo from './translateTo';

export default {
  getTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo,
};
